import { RDocument } from "@/components/DocumentViewCards/RDocument";
import { RouteConfig } from "vue-router";
import { REmployerEmployeesTemplateDocumentsBrowse } from "./components/REmployerEmployeesTemplateDocumentsBrowse";
import { RUploadDocuments } from "@/modules/Documents/Upload/RUploadDocuments";

export const REmployerEmployeesTemplateDocuments: RouteConfig = {
  path: "documents",
  component: () =>
    import(
      /* webpackChunkName: "employer-employees-template-documents" */
      "./VEmployerEmployeesTemplateDocuments.vue"
    ),
  meta: {
    title: "Employees",
    label: "documents",
  },
  children: [REmployerEmployeesTemplateDocumentsBrowse, RDocument, RUploadDocuments],
};
